export function deepStrip<T>(obj: any, template: T): T {
  // Handle arrays
  if (Array.isArray(template)) {
    return (Array.isArray(obj)
      ? obj.map(item => deepStrip(item, template[0]))
      : []) as unknown as T;
  }

  // ✅ Treat Date instances as primitives
  if (template instanceof Date || obj instanceof Date) {
    return obj as T;
  }

  // Handle plain objects
  if (typeof template === 'object' && template !== null) {
    const result: any = {};
    for (const key in template) {
      if (key in obj) {
        result[key] = deepStrip(obj[key], template[key]);
      }
    }
    return result;
  }

  // Primitive or unsupported structure
  return obj as T;
}
